import React from 'react';
import { Star } from 'lucide-react';
import { motion } from 'framer-motion';
interface StarRatingProps {
  value: number;
  onChange: (value: number) => void;
  label: string;
  showLabel?: boolean;
}
// Mapping stelle -> label gravità (stesso del ReportProblemModal)
const severityLabels: Record<number, {
  label: string;
  color: string;
}> = {
  1: {
    label: 'Minimo',
    color: 'text-green-600'
  },
  2: {
    label: 'Lieve',
    color: 'text-yellow-600'
  },
  3: {
    label: 'Moderato',
    color: 'text-orange-600'
  },
  4: {
    label: 'Grave',
    color: 'text-red-600'
  },
  5: {
    label: 'Critico',
    color: 'text-red-700'
  }
};
export function StarRating({
  value,
  onChange,
  label,
  showLabel = true
}: StarRatingProps) {
  return <div className="space-y-3" data-id="element-264">
      <label className="text-base font-semibold text-gray-700" data-id="element-265">{label}</label>
      <div className="flex gap-2" data-id="element-266">
        {[1, 2, 3, 4, 5].map(star => <motion.button key={star} type="button" onClick={() => onChange(star)} whileTap={{
        scale: 0.9
      }} className="p-2 rounded-lg hover:bg-gray-50 transition-colors touch-manipulation" data-id="element-267">
            <Star className={`w-10 h-10 transition-all ${star <= value ? 'fill-yellow-400 text-yellow-400' : 'text-gray-300'}`} strokeWidth={2} data-id="element-268" />
          </motion.button>)}
      </div>

      {/* Severity Label */}
      {showLabel && value > 0 && <motion.div initial={{
      opacity: 0,
      y: -10
    }} animate={{
      opacity: 1,
      y: 0
    }} className="flex items-center gap-2" data-id="element-269">
          <span className="text-sm text-gray-500" data-id="element-270">Livello di gravità:</span>
          <span className={`text-base font-semibold ${severityLabels[value]?.color}`} data-id="element-271">
            {severityLabels[value]?.label}
          </span>
        </motion.div>}
    </div>;
}
// Export anche le label per riuso in altri componenti
export { severityLabels };